import { UseCase, liveUseCasesWhere } from '../../../../../utils/useCases';

/**
 * The two room use cases the series form's toggle always offered, whatever the
 * tenant runs. PRESERVED: before W1-1 the toggle was these two buttons.
 */
const ALWAYS_OFFERED: readonly string[] = ['venue', 'apartment'];

/**
 * The room use cases the series form lets the operator pick, in description
 * order: the two it always offered, plus every other live room use case the
 * tenant has switched on (a sports hall, since W1-1). So a tenant without
 * sports halls sees exactly the toggle it had.
 */
export const seriesToggleUseCases = (services: readonly string[]): UseCase[] => {
    // Stored values compared case-insensitively, as everywhere a backend value is read.
    const offered = new Set(services.map((service) => String(service).trim().toLowerCase()));
    return liveUseCasesWhere((d) => d.template === 'space').filter(
        (useCase) => ALWAYS_OFFERED.includes(useCase) || offered.has(useCase),
    );
};
